import { render, staticRenderFns } from "./IpFilterConfig.vue?vue&type=template&id=1dcc6b44&scoped=true"
import script from "./IpFilterConfig.vue?vue&type=script&lang=js"
export * from "./IpFilterConfig.vue?vue&type=script&lang=js"
import style0 from "./IpFilterConfig.vue?vue&type=style&index=0&id=1dcc6b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc6b44",
  null
  
)

export default component.exports